import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { FikaBeverageAddressCardStackContentViewModel } from './fika-beverage-address-card-stack-content-view-model';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-fika-beverage-address-card-stack-content',
  templateUrl: './fika-beverage-address-card-stack-content.component.html',
  styleUrls: ['./fika-beverage-address-card-stack-content.component.scss'],
  providers: [FikaBeverageAddressCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FikaBeverageAddressCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public viewModel: FikaBeverageAddressCardStackContentViewModel, // override
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  setupBindings() {
    super.setupBindings();
    this.listenToVirtualLabelText();
  }

  private listenToVirtualLabelText(): void {
    this.labelCalculator?.virtualLabelText$
      ?.pipe(takeUntil(this.onDestroy))
      ?.subscribe(labelText => this.viewModel.connectToVirtualLabelText(labelText));
  }
}
